import axios, { AxiosResponse } from "axios";
import { TableData } from "../../models/dtos/base/TableData";
import { ExamPageDTO } from "../../models/dtos/exams/exam/ExamPageDTO";
import { StudentExamDTO } from "../../models/dtos/exams/exam/StudentExamDTO";
import { StudentExamsDTO } from "../../models/dtos/exams/questions/ExamQuestionsView";
import { StudentExamQueryString } from "../../models/query-strings/exams/exam/StudentExamQueryString";
import BaseService from "../base/BaseService";
import { ExamIntroductionDTO } from "../../models/dtos/exams/exam/ExamIntroductionDTO";

export default class ExamService extends BaseService {
    getCurrentExams(queryString: StudentExamQueryString): Promise<TableData<StudentExamDTO>> {
        return axios.get('/StudentExam', { params: {...queryString, orderField: 'createDate'} }).then(function (response: AxiosResponse<TableData<StudentExamDTO>, any>) {
            return response.data;
        });
    }

    getExamIntroduction(examId: number): Promise<ExamIntroductionDTO> {
        return axios.get(`/StudentExams/ExamIntroduction/${examId}`).then(function (response: AxiosResponse<ExamIntroductionDTO, any>) {
            return response.data;
        });
    }

    getServerTime() {
        axios.get('', {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                const serverTime = response.headers['date'];
                console.log(serverTime);
            })
            .catch(error => {
                console.error(error);
            });
    }

    getQuestionListByID(examId: number): Promise<StudentExamsDTO> {
        return axios.get(`/StudentExams/Exam/${examId}`)
            .then(function (response: AxiosResponse<ExamPageDTO, any>) {
                var result: StudentExamsDTO = {
                    courseIds: response.data.courseIds,
                    structure: response.data.structure,
                    questions:
                        response.data.questions.map((question, key) => ({
                            additionalAttachmentId: question.additionalAttachmentId,
                            answers: question.questions,
                            questionTitle: question.questionTitle,
                            courseId: question.courseId,
                            courseTitle: question.courseTitle,
                            index: key + 1,
                            orderId: question.orderId !== null && question.orderId !== undefined ? question.orderId : key + 11,
                            parentId: question.parentId,
                            questionAttachmentId: question.questionAttachmentId,
                            questionId: question.questionId,
                            relatedQuestions: question.relatedQuestions.map((item, index) =>
                            ({
                                additionalAttachmentId: item.additionalAttachmentId,
                                questionAttachmentId: item.questionAttachmentId,
                                questionId: item.questionId,
                                answers: item.questions,
                                questionTitle: item.questionTitle,
                                orderId: item.orderId !== null && item.orderId !== undefined ? item.orderId : index + 11,
                                courseId: item.courseId,
                                courseTitle: item.courseTitle,
                                parentId: item.parentId,
                                index: index + 11,
                                relatedQuestions: []
                            }))
                        }))
                }

                return result;
            });
    }

    saveExamPercent = (body: any) => {
        return axios.post('/StudentExam/SaveExamPercent', body).then(function (response: any) {
            return response.data;
        });
    }
}